import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { FaTags } from "react-icons/fa";
import { Pagination } from "swiper/modules";
import '../News/News.css'

const newsData = [
    {
      id: 1,
      image: "n1.jpg",
      title: "Airline Safety Measures 2025",
      category: "Airlines",
      description: "New safety protocols and innovations for safer flights."
    },
    {
      id: 2,
      image: "n2.jpg",
      title: "Sustainable Aviation",
      category: "Airlines",
      description: "How airlines are reducing their carbon footprint."
    },
    {
      id: 3,
      image: "n3.jpg",
      title: "Airline Industry Recovery",
      category: "Airlines",
      description: "The path to recovery for the global airline industry post-pandemic."
    },
    {
      id: 4,
      image: "n4.jpg",
      title: "New Airline Routes for 2025",
      category: "Airlines",
      description: "Exciting new destinations added to airline networks this year."
    }
  ];
  

const News = () => {
  return (
    <section className="py-12 px-6 bg-gradient-to-r from-blue-500 to-purple-600 text-center bg-n">
      <h2 className="text-4xl font-extrabold h-sn mb-8 drop-shadow-lg">Our Latest News</h2>
      <Swiper
        slidesPerView={1}
        spaceBetween={20}
        pagination={{ clickable: true }}
        breakpoints={{
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 }
        }}
        modules={[Pagination]}
        className="w-full max-w-5xl mx-auto"
      >
        {newsData.map((news) => (
          <SwiperSlide key={news.id} className="p-4 card">
            <div className=" shadow-xl rounded-xl overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl">
              <img src={news.image} alt={news.title} className="w-full h-20 object-cover hhh" />
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-800 heading-s">{news.title}</h3>
                <span className="text-sm text-gray-500 block my-2 uppercase tracking-wide cat"><FaTags />{news.category}</span>
                <p className="text-gray-700 leading-relaxed">{news.description}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default News;
